export const HOME_CAROUSEL_KEYS = {
  SPOTIFY_EVENTS: "SpotifyEventsCarousel",
  HOME_EVENT_UPDATES_FOR_YOU: "HomeEventUpdatesForYouCarousel",
  HOME_RECOMMENDED_FOR_YOU: "HomeRecommendedForYouCarousel",
  HOME_RECOMMENDED_FOR_YOU_EVENTS: "HomeRecommendedForYouCarouselEvents",
  HOME_PRICE_DROP_CAROUSEL: "HomePriceDropCarousel",
  HOME_BECAUSE_YOU_BROWSED: "HomeBecauseYouBrowsedCarousel",
};
